"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9766 13.7376a.813.813 0 0 1-.8163-.8164.813.813 0 0 1 .8163-.8163.813.813 0 0 1 .8163.8163c0 .4309-.3628.8164-.8163.8164zm-4.0233 0a.813.813 0 0 1-.8163-.8164.813.813 0 0 1 .8163-.8163.813.813 0 0 1 .8163.8163c0 .4309-.3628.8164-.8163.8164zm5.9703 4.5819c1.2726-.916 2.0763-2.2788 2.0763-3.7757 0-2.7703-2.6791-5.0045-6.0058-5.0045-3.3266 0-6.0058 2.2342-6.0058 5.0045 0 2.7704 2.6792 5.0045 6.0058 5.0045.6921 0 1.3396-.0893 1.9647-.2681.0447-.0223.1117-.0223.1787-.0223.1116 0 .2232.0447.3125.0894l1.3173.7596c.0446.0223.067.0447.1116.0447a.2002.2002 0 0 0 .201-.2011c0-.0447-.0224-.0894-.0224-.1564 0-.0224-.1786-.6256-.2679-1.0054-.0223-.0447-.0223-.0894-.0223-.134-.0223-.1564.0446-.2681.1563-.3352z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5627 9.0146c-.5207 0-.933-.4123-.933-.933s.4123-.933.933-.933.9329.4123.9329.933c0 .499-.4122.933-.9329.933zm-4.7814 0c-.5207 0-.9329-.4123-.9329-.933s.4122-.933.933-.933c.5207 0 .9329.4123.9329.933 0 .499-.4122.933-.933.933zM9.228 4C5.2448 4 2 6.676 2 9.9989c0 1.8063.9622 3.4343 2.5063 4.527.1119.0892.2014.223.2014.4014 0 .0446-.0224.1115-.0224.1561-.1119.446-.3133 1.182-.3357 1.2043-.0223.0669-.0447.1115-.0447.1784 0 .1338.1119.2453.2461.2453.0448 0 .0896-.0223.1343-.0446l1.5888-.9144c.1119-.0669.2462-.1115.3804-.1115.0672 0 .1343 0 .2014.0223.7385.2007 1.544.3345 2.3497.3345h.4028c-.1567-.4683-.2462-.9589-.2462-1.4718 0-3.0106 2.9539-5.4636 6.579-5.4636h.4028C15.8293 6.1855 12.8307 4 9.228 4z"
  })];
};

exports.default = _default;